var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6596 11.7935C10.1237 12.2911 8.80284 13.268 7.87514 14.5459L3.48242 11.3573C5.07363 9.164 7.34065 7.48678 9.97628 6.63281L11.6535 11.7996L11.6596 11.7935Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0115 6.6328L16.3343 11.7935C15.7568 11.6092 15.1608 11.4863 14.5342 11.4371C14.3745 10.5832 14.1901 10.0057 13.9935 10.0057C13.7969 10.0057 13.6188 10.5893 13.4529 11.4371C12.8262 11.4863 12.2303 11.603 11.6528 11.7935L9.97559 6.6328C11.2412 6.22117 12.5928 6 13.9935 6C15.3943 6 16.7459 6.22117 18.0115 6.6328Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5112 11.3509L20.1185 14.5395C19.1908 13.2616 17.8699 12.2848 16.334 11.7871L18.0112 6.62646C20.6468 7.48043 22.9139 9.15765 24.5051 11.3509H24.5112Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9936 18.994H21.5688C21.5688 17.3352 21.0343 15.7932 20.125 14.546L24.5177 11.3574C26.0782 13.5016 26.9998 16.1433 26.9998 18.994H26.9936Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2276 17.8449C15.2276 18.5207 14.6746 19.0736 13.9927 19.0736C13.3107 19.0736 12.7578 18.5207 12.7578 17.8449C12.7578 17.3595 13.0404 13.5689 13.452 11.4432C13.6118 10.5892 13.7961 10.0117 13.9927 10.0117C14.1893 10.0117 14.3675 10.5954 14.5333 11.4432C14.945 13.575 15.2276 17.3595 15.2276 17.8449Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87476 14.546C6.9655 15.7932 6.431 17.3352 6.431 18.994H1C1 16.1372 1.92155 13.5016 3.48204 11.3574L7.87476 14.546Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointManagement);
export default __webpack_public_path__ + "static/media/pointManagement.5a7b4e7517b933000d53d51b975c79c4.svg";
export { ForwardRef as ReactComponent };